import React, { useState, useEffect } from 'react';
import './Home.css';
import Notification from './Notification';

function Home() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  // Notices
  const [notices] = useState([
    {
      id: 1,
      icon: '📄',
      text: 'Instructions for Central Registration at Naturopathy Registration Bord (NRB) for BNYS Medical Graduates.',
      type: 'pdf',
      url: '/pdf/Instructions(1).pdf'
    },
    {
      id: 2,
      icon: '🏥',
      text: 'Naturopathy Registration Board (NRB) is developing a Directory of Naturopathy Hospital/Clinic/Day Care/Wellness Centre/Freelancer/Online Consultation Services for easy access to Public. It is requested to provide authentic information in the Google Form link given here.',
      type: 'link',
      url: 'https://forms.gle/dqHfXXaAB3dZD1Po6'
    }
    ,
    {
      id: 3,
      icon: '📄',
      text: 'User Manual — eKYC Registration (New Users).',
      type: 'pdf',
      url: '/pdf/User%20Manual%20eKYC%20Registration%20Process%20for%20New%20Users.pdf'
    },
    {
      id: 4,
      icon: '📄',
      text: 'User Manual — Existing & CCRYN Registered Candidates',
      type: 'pdf',
      url: '/pdf/user%20manual%20for%20existing%20and%20CCRYN%20registered%20candidates.pdf'
    }
  ]);

  // Slider images
  const slides = [
    'img/acu.jpg',
    'img/Physiotherapy.jpg',
    'img/reflexology.jpg',
    'img/sunbath.jpg',
    'img/yogaback.jpeg',
  ];

  // Gallery images
  const galleryImages = [
    'img/mg1.jpg',
    'img/mg2.jpg',
    'img/mg3.JPG',
    'img/mg4.JPG',
  ];

  // Auto-slide effect
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="home">
      {/* Header */}
      <header className="top-header">
        <div className="header-inner">
          <div className="header-logos">
            <a href="/" aria-label="Go to home page">
              <img src="img/nrb.png" alt="Logo 1" className="header-logo-img" />
            </a>
            <a href="https://ayush.gov.in/" target="_blank" rel="noopener noreferrer" aria-label="Open Ministry of Ayush website">
              <img src="img/MOA.png" alt="Logo 2" className="header-logo-img" />
            </a>
          </div>

          <div className="topbar-marquee-group">
            <Notification />
            <Notification
              variant="danger"
              messages={[
                'State registration is mandatory as part of the NRB-HPR integrated registration process. Kindly download the HPR Certificate and I-card from HPR Portal through this link https://nhpr.abdm.gov.in/nhpr/v4/login'
              ]}
            />
          </div>
        </div>
      </header>

      {/* Navbar */}
      <nav className="navbar">
        <div className="navbar-inner">
          <button
            className="nav-toggle"
            aria-label="Toggle navigation"
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            <span className="nav-toggle-bar" />
            <span className="nav-toggle-bar" />
            <span className="nav-toggle-bar" />
          </button>
          <ul className={`nav-links ${menuOpen ? 'open' : ''}`}>
            <li><a href="/">Home</a></li>
            <li className="nav-dropdown">
              <a href="#about">About</a>
              <ul className="dropdown-menu">
                <li><a href="/about-us">About NRB</a></li>
                <li><a href="https://ninpune.ayush.gov.in/#!/" target="_blank" rel="noopener noreferrer">About NIN</a></li>
              </ul>
            </li>
            <li><a href="/constitution">Constitution of NRB</a></li>
            <li className="nav-dropdown">
              <a href="#directory">NRB Directory</a>
              <ul className="dropdown-menu">
                <li><a href="/doctors-list">List of Doctors Registered</a></li>
                <li><a href="/naturopathy-centers">Naturopathy Centers in India</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#events">Events</a>
              <ul className="dropdown-menu">
                <li><a href="/minute-of-meeting">Minute of Meeting (MOM)</a></li>
                <li><a href="/gallery">News & Events</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#resources">Resources</a>
              <ul className="dropdown-menu">
                <li><a href="/state-boards">State Registration Board</a></li>
                <li><a href="/medical-colleges">State Wise Yoga & Naturopathy Medical Colleges in India, 2023</a></li>
                <li><a href="/who-naturopathic-workforce">World Health Organisation (WHO) Region wise listing of countries with Naturopathic Workforce 2023</a></li>
              </ul>
            </li>
            <li className="nav-dropdown">
              <a href="#others">Others</a>
              <ul className="dropdown-menu">
                <li><a href="/bnys-syllabus">BNYS Syllabus</a></li>
                <li><a href="https://ninpune.ayush.gov.in/#!/nisargopcharVartaArchive" target="_blank" rel="noopener noreferrer">Nisargopchar Varta</a></li>
              </ul>
            </li>
            <li><a href="/contact">Contact</a></li>
            <li className="nav-cta-mobile"><a href="https://app.nrb.net.in/#/session/signin/step1">Register</a></li>
          </ul>
          <a href="https://app.nrb.net.in/#/session/signin/step1" className="nav-cta">Click here to Register</a>
        </div>
      </nav>

      {/* Slider */}
      <div className="slider-container">
        <div className="slider">
          {slides.map((slide, index) => (
            <img
              key={index}
              src={slide}
              alt={`Slide ${index + 1}`}
              className={`slide ${index === currentSlide ? 'active' : ''}`}
            />
          ))}

          <div className="slider-overlay">
            <div className="slider-text">
              <h1 className="hindi-title">प्राकृतिक चिकित्सा पंजीकरण बोर्ड</h1>
              <p className="hindi-subtitle">
                (राष्ट्रीय प्राकृतिक चिकित्सा संस्थान, आयुष मंत्रालय, भारत सरकार के तत्वावधान में)
              </p>
              <div className="space"></div>
              <h2 className="english-title">NATUROPATHY REGISTRATION BOARD</h2>
              <p className="english-subtitle">
                (Under the aegis of National Institute of Naturopathy, Ministry of Ayush, Govt. of India)
              </p>
            </div>
          </div>

          <button className="prev-button" onClick={prevSlide}>&#10094;</button>
          <button className="next-button" onClick={nextSlide}>&#10095;</button>
        </div>
      </div>

      {/* Team Section */}
      <div className="team-section">
        <div className="team-members">
          <div className="team-card">
            <img src="img/kotecha.jpg" alt="Team Member 1" className="team-photo" />
            <h3 className="team-name">Padmashree Vd. Rajesh Kotecha</h3>
            <p className="team-designation">Secretary Ministry of Ayush</p>
          </div>

          <div className="team-card">
            <img src="img/jointsecretary.jpeg" alt="Team Member 2" className="team-photo" />
            <h3 className="team-name">Ms. Alarmelmangai D</h3>
            <p className="team-designation">Joint
             Secretary Ministry of Ayush</p>
          </div>

          <div className="team-card">
            <img src="img/prataprao.jpg" alt="Team Member 3" className="team-photo" />
            <h3 className="team-name">Shri Prataprao Jadhav</h3>
            <p className="team-designation">Hon'ble Minister of State for Ayush (Independent Charge)</p>
          </div>

          <div className="team-card">
            <img src="img/Geethabshetty.PNG" alt="Team Member 4" className="team-photo" />
            <h3 className="team-name">Prof. (Dr.) Geetha B. Shetty</h3>
            <p className="team-designation">CEO, Naturopathy Registration Board</p>
          </div>
        </div>
      </div>

      {/* NRB Intro + Notice Board */}
      <div className="nrb-notice-wrapper">
        <div className="nrb-notice-container">
          <div className="nrb-intro-left">
            <h2 className="intro-title">About Naturopathy<br />Registration Board</h2>
            <p className="intro-text">
              Naturopathy Registration Board (NRB) is constituted by Ministry of Ayush, Govt. of India under the aegis of National Institute of Naturopathy, Pune. The objective of NRB is to provide central registration to Naturopathy practitioners, accreditation of Naturopathy institutions and Naturopathy Hospitals. The Naturopathy Registration Board (NRB) has been integrated with the Healthcare Professionals Registry (HPR) under the Ayushman Bharat Digital Mission (ABDM).

The integration facilitates the digital registration and identification of Naturopathy healthcare professionals and enables their registration details to be linked with the national digital health ecosystem.

All Naturopathy professionals applying for registration with NRB are required to provide the necessary details for HPR registration and verification as part of the registration process.
            </p>
            <ul className="nrb-objectives">
              <li><strong>Integration of the NRB registration system with the Healthcare Professionals Registry (HPR).</strong></li>
              <li><strong>Digital identification of registered Naturopathy healthcare professionals.</strong></li>
              <li><strong>Linking of professional registration details with the national digital health ecosystem under ABDM.</strong></li>
              <li><strong>Facilitation of a standardized digital identity for healthcare professionals.</strong></li>
              <li><strong>Enhanced accessibility and verification of professional credentials through the digital health ecosystem.</strong></li>
            </ul>
            
          </div>

          <div className="notice-board-right">
            <h2 className="notice-title">📰 Notice Board</h2>
            <div className="notice-list">
              {notices.map((notice) => (
                notice.type === 'pdf' ? (
                  <a
                    href={notice.url}
                    download
                    className="notice-list-item"
                    key={notice.id}
                  >
                    <div className="notice-icon">{notice.icon}</div>
                    <div className="notice-content">
                      <p className="notice-desc">{notice.text}</p>
                      <span className="notice-action">📥 Download PDF</span>
                    </div>
                  </a>
                ) : (
                  <a
                    href={notice.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="notice-list-item"
                    key={notice.id}
                  >
                    <div className="notice-icon">{notice.icon}</div>
                    <div className="notice-content">
                      <p className="notice-desc">{notice.text}</p>
                      <span className="notice-action">🔗 Open Link</span>
                    </div>
                  </a>
                )
              ))}
            </div>
            {/* HPR Notice inside Notice Board */}
            <div className="notice-list-item hpr-notice">
              <div className="notice-icon">ℹ️</div>
              <div className="notice-content">
                <p className="notice-desc hpr-main-text">Applicants may complete the HPR registration/verification process through the NRB registration portal using their NRB login credentials.</p>
                <p className="hpr-note"><strong>Note:</strong> State registration details are required as part of the NRB-HPR integrated registration process.</p>
              </div>
            </div>
            {/* User manuals are included in the `notices` array above and will render here via the existing mapping */}
          </div>
          
        </div>
      </div>

      {/* Objectives + Gallery */}
      <div className="objectives-wrapper">
        <div className="objectives-container">
          <div className="objectives-left">
            <h2 className="objectives-heading">Objectives of Naturopathy<br />Registration Board</h2>
            <ul className="objectives-list">
              <li>To provide registration to Naturopathy practitioners.</li>
              <li>To provide registration to Para-Medicos in the field of Naturopathy.</li>
              <li>To provide accreditation to Naturopathy institutions and Naturopathy Hospitals.</li>
              <li>To promote and propagate a rational and safe Naturopathy practice and non-drug combination therapeutics across the country.</li>
              <li>To devise a mechanism to identify those Naturopathy practitioners who are from varied medical backgrounds for offering them a registration under NRB under a separate chapter after due training.</li>
              <li>To prescribe minimum standards of education in Naturopathy system of Medicine.</li>
              <li>To recommend the Central Government in matters relating to recognition (inclusion, withdrawal) of medical qualifications in Naturopathy. To maintain a Central Register for Naturopathy physicians and Naturopathy paramedical professionals and revise the Register from time to time.</li>
              <li>To prescribe Standards of Professional Conduct, Etiquette, and Code of Ethics to be observed by the practitioners.</li>
            </ul>
          </div>

          <div className="objectives-right" id="gallery">
            <div className="photo-gallery">
              <h3 className="gallery-title">Event Gallery</h3>
              <div className="gallery-masonry">
                {galleryImages.map((img, index) => (
                  <div key={index} className="masonry-item">
                    <img
                      src={img}
                      alt={`Gallery ${index + 1}`}
                      className="masonry-photo"
                    />
                  </div>
                ))}
              </div>
              <p className="gallery-caption">Naturopathy Registration Board</p>
            </div>
          </div>
        </div>
      </div>
      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section">
            <h3 className="footer-heading">Naturopathy Registration Board</h3>
            <p className="footer-desc">
              Regulating and promoting excellence in Naturopathy education and practice across India.
            </p>
            <div className="footer-logos">
              <img src="img/nrb.png" alt="NRB Logo" className="footer-logo" />
              <img src="img/MOA.png" alt="Ministry Logo" className="footer-logo" />
            </div>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="/about-us">About NRB</a></li>
              <li><a href="/constitution">Constitution of NRB</a></li>
              <li><a href="/doctors-list">List of Doctors Registered</a></li>
              <li><a href="/naturopathy-centers">Naturopathy Centers in India</a></li>
              <li><a href="/contact">Contact Us</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Important Links</h4>
            <ul className="footer-links">
              <li><a href="/minute-of-meeting">Minute of Meeting (MOM)</a></li>
              <li><a href="/gallery">News &amp; Events</a></li>
              <li><a href="/state-boards">State Registration Board</a></li>
              <li><a href="/medical-colleges">Medical Colleges</a></li>
              <li><a href="/who-naturopathic-workforce">WHO Naturopathic Workforce</a></li>
              <li><a href="/bnys-syllabus">BNYS Syllabus</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Contact Information</h4>
            <div className="footer-contact">
              <p>Dr Kajal Gupta (Domain Expert), NRB</p>
              <p>📧 nrb@bharatmail.co.in</p>
              <p>📞 86258 33306</p>
              <p>🕐 Mon-Fri: 10:00 AM - 6:00 PM</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 Naturopathy Registration Board. All rights reserved.</p>
          <div className="footer-bottom-links">
            <a href="#privacy">Privacy Policy</a>
            <span>|</span>
            <a href="#terms">Terms & Conditions</a>
            <span>|</span>
            <a href="#sitemap">Sitemap</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Home;

